import {
  getWorksList,
  getWorkDetail,
  createWork,
  updateWork,
  deleteWork,
  publishWork,
  unpublishWork,
  getWorkStats
} from '@/api/works'

const state = {
  worksList: [],
  currentWork: null,
  workStats: {},
  total: 0,
  loading: false,
  filters: {
    page: 1,
    limit: 12,
    status: '',
    category: '',
    keyword: ''
  }
}

const mutations = {
  SET_WORKS_LIST: (state, works) => {
    state.worksList = works
  },
  SET_CURRENT_WORK: (state, work) => {
    state.currentWork = work
  },
  SET_WORK_STATS: (state, stats) => {
    state.workStats = stats
  },
  SET_TOTAL: (state, total) => {
    state.total = total
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading
  },
  SET_FILTERS: (state, filters) => {
    state.filters = { ...state.filters, ...filters }
  },
  RESET_FILTERS: (state) => {
    state.filters = {
      page: 1,
      limit: 12,
      status: '',
      category: '',
      keyword: ''
    }
  },
  ADD_WORK: (state, work) => {
    state.worksList.unshift(work)
    state.total++
  },
  UPDATE_WORK_IN_LIST: (state, updatedWork) => {
    const index = state.worksList.findIndex(w => w.id === updatedWork.id)
    if (index !== -1) {
      state.worksList.splice(index, 1, updatedWork)
    }
  },
  REMOVE_WORK_FROM_LIST: (state, workId) => {
    const index = state.worksList.findIndex(w => w.id === workId)
    if (index !== -1) {
      state.worksList.splice(index, 1)
      state.total--
    }
  }
}

const actions = {
  // 获取作品列表
  getWorksList({ commit, state }) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      getWorksList(state.filters).then(response => {
        const { data, total } = response
        commit('SET_WORKS_LIST', data)
        commit('SET_TOTAL', total)
        resolve(response)
      }).catch(error => {
        reject(error)
      }).finally(() => {
        commit('SET_LOADING', false)
      })
    })
  },

  // 获取作品详情
  getWorkDetail({ commit }, id) {
    commit('SET_LOADING', true)
    return new Promise((resolve, reject) => {
      getWorkDetail(id).then(response => {
        const { data } = response
        commit('SET_CURRENT_WORK', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      }).finally(() => {
        commit('SET_LOADING', false)
      })
    })
  },

  // 创建作品
  createWork({ commit }, workData) {
    return new Promise((resolve, reject) => {
      createWork(workData).then(response => {
        const { data } = response
        commit('ADD_WORK', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 更新作品
  updateWork({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      updateWork(id, data).then(response => {
        const { data: updatedWork } = response
        commit('UPDATE_WORK_IN_LIST', updatedWork)
        if (state.currentWork && state.currentWork.id === id) {
          commit('SET_CURRENT_WORK', updatedWork)
        }
        resolve(updatedWork)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 删除作品
  deleteWork({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteWork(id).then(() => {
        commit('REMOVE_WORK_FROM_LIST', id)
        if (state.currentWork && state.currentWork.id === id) {
          commit('SET_CURRENT_WORK', null)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 批量删除作品
  batchDeleteWorks({ commit, dispatch }, ids) {
    return new Promise((resolve, reject) => {
      // 实际开发中调用批量删除API
      Promise.all(ids.map(id => deleteWork(id))).then(() => {
        dispatch('getWorksList')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 发布作品
  publishWork({ commit }, id) {
    return new Promise((resolve, reject) => {
      publishWork(id).then(response => {
        const { data } = response
        commit('UPDATE_WORK_IN_LIST', data)
        if (state.currentWork && state.currentWork.id === id) {
          commit('SET_CURRENT_WORK', data)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 下架作品
  unpublishWork({ commit }, id) {
    return new Promise((resolve, reject) => {
      unpublishWork(id).then(response => {
        const { data } = response
        commit('UPDATE_WORK_IN_LIST', data)
        if (state.currentWork && state.currentWork.id === id) {
          commit('SET_CURRENT_WORK', data)
        }
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取作品统计数据
  getWorkStats({ commit }) {
    return new Promise((resolve, reject) => {
      getWorkStats().then(response => {
        const { data } = response
        commit('SET_WORK_STATS', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 设置筛选条件
  setFilters({ commit }, filters) {
    commit('SET_FILTERS', filters)
  },

  // 重置筛选条件
  resetFilters({ commit }) {
    commit('RESET_FILTERS')
  },

  // 清除当前作品
  clearCurrentWork({ commit }) {
    commit('SET_CURRENT_WORK', null)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}